import { createRoute } from "@tanstack/react-router";

import { teamRoute } from "../../platform/routes";
import { TeamHome } from "./HomeScreens";

export const teamHomeRoute = createRoute({
  getParentRoute: () => teamRoute,
  path: "/",
  component: TeamHome,
});
